import React from 'react'

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px 16px',
    background: 'var(--color-light)',
    border: '2px solid var(--color-border)',
  },
  time: {
    fontFamily: 'var(--font-mono)',
    fontSize: '1.5rem',
    fontWeight: '700',
    minWidth: '80px',
  },
  button: {
    padding: '6px 12px',
    border: '2px solid var(--color-border)',
    background: '#fff',
    fontWeight: '600',
    cursor: 'pointer',
  },
}

export default function Timer({ seconds, isRunning, onToggle, formatTime }) {
  return (
    <div style={styles.container}>
      <span style={styles.time}>{formatTime(seconds)}</span>
      <button style={styles.button} onClick={onToggle}>
        {isRunning ? 'Pause' : 'Resume'}
      </button>
    </div>
  )
}
